<template>
  <div class="tasks-list" v-if="userRoleGroup">
    <div class="header">
      <span class="number">{{ $t('projectDetails.tasksList.number') }}</span>
      <span class="done">{{ $t('projectDetails.tasksList.done') }}</span>
      <span class="scope">{{ $t('projectDetails.tasksList.scope') }}</span>
    </div>

    <div class="tasks-list-content">
      <tasks-list-row
        v-for="(item, index) in detailedProject.resources"
        :item="item"
        :itemIndex="index + 1"
        :key="item.id"
        :project="detailedProject"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { views } from '@/router/constants';
import { userRoleGroups } from '@/constants/auth';
import { projectStatuses } from '@/constants/projects';
import TasksListRow from '@/components/ProjectDetails/tasks/TasksListRow.vue';

export default {
  name: 'TasksList',
  components: {
    TasksListRow,
  },
  computed: {
    ...mapGetters(['detailedProject', 'userRoleGroup']),
    isUserSP() {
      return this.userRoleGroup === userRoleGroups.SP;
    },
  },
  watch: {
    userRoleGroup() {
      if (this.isUserSP && this.detailedProject.status !== projectStatuses.IN_PROGRESS) {
        this.$router.replace({ name: views.PROJECT_GENERAL_INFORMATION });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.tasks-list {
  .header {
    display: flex;
    padding-top: 25px;
    padding-bottom: $space-2;

    .tasks-list-content {
      overflow: auto;
    }

    span {
      text-transform: uppercase;
      color: var(--text-tertiary);
      font-size: $font-size-xs;
      letter-spacing: 0.8px;
      line-height: $font-size-xs;
    }

    .number {
      margin-right: $space-5;
    }

    .done {
      margin-right: 35px;
    }
  }
}
</style>
